import Vue from 'vue'

import Component from 'vue-class-component'

Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate' // for vue-router 2.2+
]);

import App from './App.vue'
import router from './router'
import store from './store'

import vuetify from './plugins/vuetify';
import 'vuetify/dist/vuetify.min.css';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import IdleVue from 'idle-vue';

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/free-regular-svg-icons'

// globally _loading extension methods
require("@/extensions");

Vue.config.productionTip = false;

export const eventBus = new Vue({
    router,
    store,
    components: {},
    vuetify,
    render: h => h(App)
})


Vue.use(IdleVue, {
    eventEmitter: eventBus,
    idleTime: process.env.VUE_APP_LOGOUT_UNTIL_WARN_S * 1000, // in ms
    startAtIdle: false,
})

eventBus.$mount('#app');



